module.exports = __webpack_public_path__ + "img/printer-fill.352f7129.svg";